import withLocale from '~/lang/with-locale';
import AuthProvider from '../../providers/AuthProvider';
import { HeaderProvider } from '~/providers/HeaderProvider/HeaderContext';

/**
 * @typedef {Object} AppProps
 * @property {import('next').NextPage<any, any>} Component - The Next.js page component to render.
 * @property {import('next/router').NextRouter} router - The Next.js router instance.
 * @property {any} pageProps - The props for the page component.
 */

/** @function
 * @param {AppProps} props - The properties passed to the component.
 * @returns {React.ReactElement} - The rendered application component.
 * @description This is the main application component for the server-side rendered Next.js app.
 * It wraps the application in an authentication provider and sets up an intersection observer
 * to handle fade-in animations for elements with the class 'waiting-for-fade-in'.
 * The observer triggers the fade-in effect when the elements come into view, enhancing the user experience.
 * It also uses a custom locale provider to manage internationalization.
 */
function ServerApp({ Component, pageProps }) {
  return (
    <>
      {/* @ts-ignore */}
      <AuthProvider>
        <HeaderProvider>
          {/* @ts-ignore */}
          <Component {...pageProps} />
        </HeaderProvider>
      </AuthProvider>
    </>
  );
}

export default withLocale(ServerApp);
